<script setup>
import { ref } from 'vue'
import { useSessionStore } from '../stores/session'

defineEmits(['close'])
const session = useSessionStore()
const email = ref('')
const code = ref('')
const step = ref('email')
const error = ref('')
const busy = ref(false)
const developmentCode = ref('')

async function requestCode() {
  busy.value = true; error.value = ''
  try {
    const result = await session.requestCode(email.value)
    developmentCode.value = result.development_code || ''
    step.value = 'code'
  } catch (reason) { error.value = reason.message }
  finally { busy.value = false }
}

async function verify() {
  busy.value = true; error.value = ''
  try { await session.verify(email.value, code.value) }
  catch (reason) { error.value = reason.message }
  finally { busy.value = false }
}
</script>

<template>
  <div class="dialog-backdrop" @click.self="$emit('close')">
    <section class="auth-dialog" role="dialog" aria-modal="true" aria-labelledby="auth-title">
      <button class="dialog-close" type="button" aria-label="Закрыть" @click="$emit('close')">×</button>
      <h2 id="auth-title">Сохрани свои игры</h2>
      <p>Войди по почте — текущая гостевая история останется с тобой.</p>
      <form v-if="step === 'email'" @submit.prevent="requestCode">
        <label for="login-email">Почта</label>
        <input id="login-email" v-model="email" type="email" autocomplete="email" placeholder="you@example.com" required />
        <button class="button button-primary" :disabled="busy">{{ busy ? 'Отправляем…' : 'Получить код' }}</button>
      </form>
      <form v-else @submit.prevent="verify">
        <label for="login-code">Код из письма</label>
        <input id="login-code" v-model="code" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="000000" required />
        <p v-if="developmentCode" class="dev-code">Код для разработки: <b>{{ developmentCode }}</b></p>
        <button class="button button-primary" :disabled="busy">{{ busy ? 'Проверяем…' : 'Войти' }}</button>
        <button class="text-button" type="button" @click="step = 'email'">Изменить почту</button>
      </form>
      <p v-if="error" class="form-error" role="alert">{{ error }}</p>
      <div class="guest-note">Можно продолжить гостем. Игры сохраняются на этом устройстве и перенесутся после входа.</div>
    </section>
  </div>
</template>
